import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-layer-select-modal',
	templateUrl: './layer-select-modal.component.html',
	styleUrls: ['./layer-select-modal.component.css']
})
export class LayerSelectModalComponent implements OnInit {

	public fgdb: string;
	public enableOk: boolean;
	public layers: {
		name: string;
		selected: boolean;
	}[];
	// public selectedLayers;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dialogRef: MatDialogRef<LayerSelectModalComponent>
	) { }

	setEnableOk() {
		for(let i = 0; i < this.layers.length; i++) {
			if(this.layers[i].selected == true) {
				this.enableOk = true;
				return;
			}
		}
		this.enableOk = false;
		return;
	}
	onClickLayer(idx) {
		this.layers[idx].selected = !this.layers[idx].selected;
		this.setEnableOk();
	}
	close(res: 'ok' | 'cancel') {
		if (res === 'ok') {
			const selected = this.layers.filter(l => l.selected).map(l => l.name);
			this.dialogRef.close(selected);
		} else {
			this.dialogRef.close();
		}
	}
	ngOnInit() {
		this.enableOk = false;
		this.fgdb = this.data.fgdb;
		this.layers = (<any[]>this.data.layers).map(l => {
			return {
				name: l,
				selected: false
			}
		});
	}

}
